<div
  class="email-panel-footer row no-margin work-widget-panel-footer bc-panel-maxh"
  data-automation-id="gc-email-footer"
  *ngIf="isFocused && footerMode$ | async as footerMode"
>
  <ng-container *ngIf="composedEmail$ | async as composedEmail">
    <div class="email-panel-footer-controls">
      <app-alert-box [editorMessages]="editorMessages$ | async" (closeHandler)="clearEditorMessages()"></app-alert-box>
      <div *ngIf="footerMode | appIsFooterModeActive: 'CONTROL_PANEL'" data-automation-id="gc-email-control-panel">
        <div class="bc-email-control-panel" [@slideInFromBottomAnimation]>
          <app-genesys-email-footer-control-panel
            [isInteractionDisabled]="interactionDisabled$ | async"
            [isExpanded]="isExpanded"
            (reply)="onReply()"
            (forward)="onForward()"
            (replyAll)="onReplyAll()"
            (confirmation)="handleConfirmation()"
            (wrapUp)="onOpenWrapUpPanel()"
            (openTransferPanel)="onOpenTransferPanel()"
          ></app-genesys-email-footer-control-panel>
        </div>
      </div>

      <app-genesys-email-wrapup-panel
        *ngIf="footerMode | appIsFooterModeActive: 'WRAPUP'"
        [conversationId]="conversationId"
        [selectedWrapUp]="selectedWrapUpCode$ | async"
        (selectWrapUpCode)="selectWrapUp($event)"
        (toggleWrapUpPanel)="onCancelFooterMode()"
      ></app-genesys-email-wrapup-panel>

      <app-genesys-email-outgoing-header
        *ngIf="footerMode | appIsFooterModeActive: 'RECIPIENTS'"
        class="recipients"
        [model]="composedEmail"
        (save)="onHeaderSave($event)"
        (cancel)="onHeaderCancel()"
      >
      </app-genesys-email-outgoing-header>

      <div class="js-outgoing-email" *ngIf="footerMode | appIsFooterModeActive: 'EDITOR'">
        <app-genesys-email-editor
          *ngIf="isExpanded || (isMoreActionsVisible$ | async) === false"
          [conversationId]="conversationId"
          [lastEmail]="lastEmail"
          [htmlBody]="composedEmail?.htmlBody"
          [draftAttachments]="draftEmail?.attachments"
          [showQuoteButton]="(isQuotedMessageAdded$ | async) === false"
          (addQuotedContent)="addQuotedContent($event)"
          (editorContentChange)="onEditorContentChanged($event)"
        ></app-genesys-email-editor>

        <div class="bc-footer-buttons clearfix" *ngIf="isExpanded">
          <app-genesys-email-action-buttons
            [conversationId]="conversationId"
            [isInteractionDisabled]="isInteractionDisabled$ | async"
            [isExpanded]="true"
            (send)="onSend(composedEmail)"
            (openOutgoingHeader)="openOutgoingHeaderPanel()"
            (attachmentSizeLimitError)="onAttachmentSizeLimitError($event)"
            (replyCancel)="onReplyCancel()"
            (handleConfirmation)="handleConfirmation()"
            (openWrapUpPanel)="onOpenWrapUpPanel()"
          ></app-genesys-email-action-buttons>
        </div>

        <app-more-actions-panel
          *ngIf="!isExpanded"
          [isOpen]="isMoreActionsVisible$ | async"
          [openFocusTarget]="focusTarget"
          (togglePanel)="toggleMoreActions()"
          class="more-actions"
        >
          <div class="container-fluid" #focusTarget tabindex="-1">
            <div class="control-panel-groups">
              <app-genesys-email-action-buttons
                [conversationId]="conversationId"
                [isInteractionDisabled]="isInteractionDisabled$ | async"
                (send)="onSend(composedEmail)"
                (openOutgoingHeader)="openOutgoingHeaderPanel()"
                (attachmentSizeLimitError)="onAttachmentSizeLimitError($event)"
                (replyCancel)="onReplyCancel()"
                (handleConfirmation)="handleConfirmation()"
                (openWrapUpPanel)="onOpenWrapUpPanel()"
              ></app-genesys-email-action-buttons>
            </div>
          </div>
        </app-more-actions-panel>
      </div>
    </div>

    <app-genesys-email-close-confirmation-modal
      *ngIf="isConfirmationModalVisible$ | async"
      [conversationId]="conversationId"
      (closeConfirmationModal)="closeConfirmation()"
    ></app-genesys-email-close-confirmation-modal>
  </ng-container>
</div>
